import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { XOR } from 'types';

import './StatusBadge.styles.scss';

type ShowSponsored = {
  sponsored: boolean;
};

type ShowNew = {
  isNew: boolean;
};

type StatusBadgeProps = {
  className?: string;
} & XOR<ShowNew, ShowSponsored>;

const StatusBadge: React.FC<StatusBadgeProps> = ({
  className,
  isNew,
  sponsored,
}) => {
  const { t } = useTranslation();

  const classes = classNames(
    'res-status-badge',
    {
      sponsored,
      new: isNew,
    },
    className,
  );

  if (!isNew && !sponsored) return null;

  return (
    <div className={classes}>
      <div>{t(sponsored ? 'sponsored' : 'new')}</div>
    </div>
  );
};

export default StatusBadge;
